module.exports = __webpack_public_path__ + "img/ski_title2.a20fd9f9.png";